import { useMutation } from '@tanstack/react-query';

import { ZoneRuleFormSchemaValues } from 'src/features/membershipType/formSchema';
import { ZoneRule } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/memberships/membership/:membershipId/zone-rules/:ruleId/`;

type MutationFnType = typeof mutationFn;

interface DTO extends ZoneRuleFormSchemaValues {
    parkingId: string;
    membershipId: string;
    ruleId: string;
}
const mutationFn = ({ membershipId, ruleId, parkingId, ...data }: DTO): Promise<ZoneRule> => {
    return axios.put(formatResourcePath(RESOURCE, { parkingId, membershipId, ruleId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateMembershipZoneRule };
